/**
 * Wrapper for front end app's configuration.
 */
export default class FrontEndConfig {
    env: string = ""; // used to differentiate between environments (ametiq / lukb) in runtime
    apiUrl: string = ""; // what base url to use for api calls (without host:port part)
    other: string = ""; // link to navigate to after the process is completed
}
